"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsTools = require("@airportlabs/js-tools");
var _redirectToLogin = _interopRequireDefault(require("./redirectToLogin"));
var _tokens = require("./tokens");
var redirectToLoginIfNoAccessToken = function redirectToLoginIfNoAccessToken() {
  var withBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var accessToken = (0, _tokens.getAccessToken)();
  if (!accessToken) {
    _jsTools.authConsole.log("No access token found. Redirecting to login.");
    (0, _redirectToLogin["default"])(withBack);
    return {
      isTokenMissing: true
    };
  }
  return {
    isTokenMissing: false
  };
};
var _default = exports["default"] = redirectToLoginIfNoAccessToken;